import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { productListSingleViewAPICall } from '../../../../API/Product List/productListAPI';

export const ProductListSingleView = () => {
    const singleRowId = localStorage.getItem("singleViewById");
    const allProductsListSingle = useSelector(
        (state) => state.allProductsListSlice.singleView
      );
    const navigateTo=useNavigate()
    const backToProduct=()=>{
        navigateTo("/userdashboard/productList")
    }

    useEffect(()=>{
        if (singleRowId) {
        productListSingleViewAPICall({productId:singleRowId})
        }
    },[])
  return (
    <div className="global-page-parent-container" style={{ margin: "0" }}>
    <div className='global-white-bg-container'style={{backgroundColor:"unset",padding:"4px"}}>
        <div style={{display:"flex",backgroundColor:"white",padding:"12px"}}>
            <p onClick={backToProduct} style={{cursor:"pointer",margin:"0 8px",fontSize:"0.8rem",fontWeight:600}}>PRODUCT LIST</p>
            <p style={{margin:"0 8px",fontSize:"0.8rem",fontWeight:600}}><i class="bi bi-chevron-right"></i></p>
            <p style={{margin:"0 8px",fontSize:"0.8rem",fontWeight:600}}>{allProductsListSingle?.productName}</p>
            
        </div>
        <div className='new-global-table-container' style={{marginTop:"4px"}}>
            <table>
                <thead>
                    <tr>
                        <th>Branch Name</th>
                        <th style={{color:"red"}}>Closing Stock</th>
                        <th style={{color:"blue"}}>Unit Cost</th>
                        <th>Stock Value</th>
                    </tr>
                </thead>
                <tbody>
                    {allProductsListSingle!==undefined?
                        allProductsListSingle?.list?.map((r)=>(
                            <tr>
                            <td>{r?.branchName}</td>
                            <td style={{color:"red"}}>{r?.stock}</td>
                            <td style={{color:"blue"}}>{r?.unitCost}</td>
                            <td>{r?.stockValue}</td>
                        </tr>)):
                        <tr>
                            <td colSpan={4}>No Data</td>
                        </tr>
                    }
                 
                   
                </tbody>
                {
                   allProductsListSingle!==undefined && 
                    <thead>
                    <tr>
                        <th>Total</th>
                        <th style={{color:"red"}}>{allProductsListSingle?.totalClosingStock}</th>
                        <th style={{color:"blue"}}></th>
                        <th>{allProductsListSingle?.totalStockValue}</th>
                    </tr>
                </thead>}
            </table>
        </div>
    </div>
    </div>
  )
}
